import { api } from "@/api/utils";
import { queryOptions } from "@tanstack/react-query";

export const countryCapabilitiesQuery = (countryCode?: string) =>
  queryOptions({
    queryKey: ["country-caps", countryCode],
    queryFn: async () => {
      const response = await api.location.getCountry({ countryCode: countryCode as any });
      return response.capabilities;
    },
    enabled: !!countryCode,
  });

